import React, { useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import minus from '../../assets/minus.svg'
import plus from '../../assets/plus.svg'
import up from '../../assets/arrow-up.svg'
import down from '../../assets/arrow-down.svg'

interface AccordionItemProps {
  handleToggle: (id: string) => void
  active: string | null
  header: React.ReactNode
  id: string
  content: React.ReactNode
  mode?: 'accordion' | 'menu'
  subAccordion?: boolean

}

export const AccordionItem: React.FC<AccordionItemProps> = ({
  handleToggle,
  active,
  header,
  id,
  content,
  mode = 'accordion',
  subAccordion = false,

}) => {
  const contentEl = useRef<HTMLDivElement | null>(null)
  const [contentHeight, setContentHeight] = useState(0)

  useEffect(() => {
    if (contentEl.current) {
      setContentHeight(contentEl.current.scrollHeight)
    }
  }, [content])

  return (
    <Card subAccordion={subAccordion} $expanded={active === id}>
      <Header onClick={() => handleToggle(id)}>
        {header} 
        {mode === 'menu' ? (
          <img src={active === id ? up : down} alt="Toggle Icon" />
        ) : (
          <img src={active === id ? minus : plus} alt="Toggle Icon" />
        )}
      </Header>
      <Content
        ref={contentEl}
        className={active === id ? 'show' : ''}
        style={{
          height: active === id ? `${contentHeight}px` : '0px',
        }}
      >
        {content}
      </Content>
    </Card>
  );
};

const Card = styled.div<{ $expanded?: boolean }>`
  background: ${(props) => props.subAccordion ? '#2e2c3e' : '#3b3752' };
  color: ${(props) => props.theme.textWhite};
  border-radius: 8px;
  margin-bottom: 24px;
  padding: 0 32px;
  overflow: ${(props) => props.$expanded ? 'visible' : 'hidden'};

  &:last-child {
    margin-bottom: 0;
  }

  th {
    padding-top: 16px;
    padding-bottom: 16px;
  }
`

const Header = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  transition: opacity 0.15s;
  min-height: 48px;

  &:hover { opacity: 0.8; }

  img {
    height: 16px;
    opacity: 0.35;
    filter: brightness(10);
  }
`

const Content = styled.div`
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.25s ease;

  &.show {
    height: auto;
    overflow: visible;
    border-top: 1px solid #403c52;
  }
`

export default AccordionItem
